import { LayerDefinition } from './types';

export const streamflowDefinition: LayerDefinition = {
  id: 'streamflow',
  name: 'Water Temperature & Streamflow',
  category: 'environment',
  categoryLabel: 'Hydrology & Inland Waters',
  icon: '🌊',
  description: 'Real-time USGS river and stream telemetry monitoring flow discharge rates (cfs), gauge height, and water temperatures.',
  sourceModels: ['USGS National Water Information System (NWIS) Telemetry'],
  outputModels: ['Streamflow station telemetry markers', 'Inland water temperature raster']
};

export default streamflowDefinition;
